/* eslint-disable react/jsx-props-no-spreading */
import { FC, ComponentProps, useState } from 'react';
import { Control, Controller, FieldValues } from 'react-hook-form';
import { Box, Timepicker } from '@altermaind/web/ui';

type Props = {
  control: Control<FieldValues>;
  name: string;
  containerProps?: ComponentProps<typeof Box>;
  additonalProps?: Record<string, unknown>;
} & ComponentProps<typeof Timepicker>;

export const WrappedTimePicker: FC<Props> = ({
  control,
  name,
  additonalProps,
  containerProps,
  ...props
}) => {
  const [, setTime] = useState<string>('');

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Box {...containerProps}>
      <Controller
        control={control}
        name={name}
        rules={{ ...additonalProps }}
        render={({ field }) => (
          <Timepicker
            onTimeChange={selectedTime => {
              setTime(selectedTime);
              field.onChange(selectedTime);
            }}
            {...field}
            {...props}
          />
        )}
      />
    </Box>
  );
};
